import Header from './components/Header';
import Hero from './components/Hero';
import SectionUpdates from './components/SectionUpdates';
import SectionMedia from './components/SectionMedia';
import SectionTopics from './components/SectionTopics';
import SectionApp from './components/SectionApp';
import SectionCarousel from './components/SectionCarousel';
import SectionRanking from './components/SectionRanking';
import SectionIndex from './components/SectionIndex';
import SectionFeatures from './components/SectionFeatures';
import SectionAbout from './components/SectionAbout';
import SectionComments from './components/SectionComments';
import SectionFaq from './components/SectionFaq';
import SectionContact from './components/SectionContact';
import SectionCards from './components/SectionCards';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionUpdates />
        <SectionMedia />
        <SectionTopics />
        <SectionApp />
        <SectionCarousel />
        <SectionRanking />
        <SectionIndex />
        <SectionFeatures />
        <SectionAbout />
        <SectionComments />
        <SectionFaq />
        <SectionContact />
        <SectionCards />
      </main>
      <Footer />
    </>
  );
}